<template>
  <div class="chart-container">
    <div class="chart-title">
      昨日消耗
      <Tooltip content="近15天的消耗和日环比">
        <i
          class="el-icon-question"
          style="margin-left: 4px;"
        />
      </Tooltip>
    </div>
    <div class="chart-cost">{{ cost }}</div>
    <Chart
      :dataSource="dataSource"
      :options="options"
      :height="110"
    />
  </div>
</template>

<script>
import { Tooltip } from 'element-ui';
import { isEmpty, toNumber } from 'lodash';
import accounting from 'accounting';

import { fenToYuan } from '@/common/number/';

import Chart from '@/components/Chart/';

import Request from '@/core/QuRequest';

const req = new Request();

export default {
  components: {
    Chart,
    Tooltip,
  },

  props: {
    customerId: {
      type: String,
      required: true,
    },

    productId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dataSource: null,
      cost: 0,
      options: {
        xAxis: {
          show: false,
        },
        tooltip: {
          formatter(params) {
            let res = `${params[0].axisValue}<br>`;
            params.forEach((param) => {
              const { data } = param;
              const value =
                data._raw.valueType === 'money'
                  ? accounting.formatMoney(data.value, '￥')
                  : `${data.value}%`;
              res += `
                ${param.marker}
                <span>${param.seriesName}</span>: 
                <span>${value}</span><br>
              `;
            });
            res += `
              ${params[0].marker}
              <span>涨幅</span>: 
              <span>${accounting.formatNumber(
                fenToYuan(params[0].data._raw._raw.cost_add),
              )}</span><br>
            `;
            return res;
          },
        },
      },
    };
  },

  watch: {
    productId() {
      this.customerMyProductChart();
    },
  },

  mounted() {
    this.customerMyProductChart();
  },

  methods: {
    async customerMyProductChart() {
      try {
        const res = await req.send(
          req.Apis.sales.customer.customerMyProductChart,
          {
            customer_id: this.customerId,
            product_id: this.productId,
          },
        );
        if (res.code === 200) {
          const { yest_cost, list } = res.data;
          this.dataSource = this.convert(list);
          this.cost = accounting.formatMoney(fenToYuan(yest_cost), '￥');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 数据转换
    convert(data) {
      if (isEmpty(data)) return;

      // 两种图表
      const bar = []; // 柱状
      const line = []; // 折线
      const keys = Object.keys(data);
      keys.forEach((key) => {
        const item = data[key];

        bar.push({
          key: 'cost',
          label: '消耗',
          xAxis: item.date,
          series: toNumber(item.cost),
          type: 'bar',
          valueType: 'money',
          _raw: item,
        });

        line.push({
          key: 'cost_rate',
          label: '日环比',
          xAxis: item.date,
          series: item.cost_rate,
          type: 'line',
          valueType: 'percent',
          _raw: item,
        });
      });

      return { base: { bar, line } };
    },
  },
};
</script>

<style lang="less" scoped>
.chart {
  &-container {
    box-shadow: 0px 0px 12px 0px rgba(164, 168, 175, 0.2);
    border-radius: 4px;
    padding: 16px;
    box-sizing: border-box;
  }

  &-title {
    font-size: 14px;
    font-weight: 400;
    color: rgba(144, 147, 153, 1);
    line-height: 14px;
  }

  &-cost {
    font-size: 24px;
    font-weight: bold;
    color: rgba(48, 49, 51, 1);
    line-height: 24px;
    margin-top: 8px;
  }
}
</style>